export const runFetch = async (endpoint, token, apiOrigin, method = "GET", body) => {
  const response = await fetch(`${apiOrigin}${endpoint}`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    method,
    ...(body && {
      body
    })
  })

  if (!response.ok) {
    const payload = await response.json()
    const status = response.status
    const statusText = response.statusText
    throw Object.assign(new Error("Error calling api."), { payload, status, statusText })
  }

  const data = await response.json()
  return data
}

export const callApi = async (endpoint, token, apiOrigin, method = "GET", body) => {
  const result = {
    loading: true,
    data: null,
    error: null
  }

  return runFetch(endpoint, token, apiOrigin, method, body)
    .then((data) => (result.data = data))
    .catch((error) => (result.error = error))
    .finally(() => (result.loading = false))
    .then(() => result)
}
